export default class MemberTitlesJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.memberTitlesEndpoint, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberTitlesEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.memberTitlesEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.memberTitlesEndpoint, {
      params
    })
  }
}
